import type { ReactElement, ReactNode } from 'react';

export type StatusKind = 'loading' | 'empty' | 'error';

export interface StatusStateProps {
  kind: StatusKind;
  title: string;
  message?: string;
  action?: ReactNode;
  /** Fill the page instead of sitting inline. */
  page?: boolean;
}

export function StatusState({ kind, title, message, action, page = false }: StatusStateProps): ReactElement {
  return (
    <div
      role={kind === 'error' ? 'alert' : 'status'}
      aria-busy={kind === 'loading' || undefined}
      className={`m-0 p-0 border-0 bg-transparent font-ui ${page ? 'min-h-[60vh] grid place-items-center' : 'py-6'}`}
    >
      <div className="m-0 p-0 flex flex-col items-center gap-2 text-center">
        <p className="m-0 p-0 text-lg font-semibold text-ink">{title}</p>
        {message ? <p className="m-0 p-0 text-md text-muted">{message}</p> : null}
        {action}
      </div>
    </div>
  );
}
